import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Button from 'components/Button';
import { useMutation } from '@apollo/client';
import { PrepareActivateConsultantMutation } from 'modules/Consultant/query';
import { Confirm, displayAlert, displaySuccess } from '_template';

interface ButtonPrepareActivateConsultantProps {
  consultant: GQL.IConsultant;
  refetch: () => void;
}

const ButtonPrepareActivateConsultant = ({
  consultant,
  refetch,
}: ButtonPrepareActivateConsultantProps) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [prepareActivateMutation] = useMutation(
    PrepareActivateConsultantMutation
  );

  const onClick = () => {
    Confirm({
      title: t('CONSULTANT.PREPARE_ACTIVATE.REALLY_TO_ACTIVATE'),
      description: t<string>(
        'CONSULTANT.PREPARE_ACTIVATE.REALLY_TO_ACTIVATE_DESCRIPTION'
      ),
      labelSubmit: t('GENERAL.YES'),
      labelSubmitVariant: 'primary',
      labelCancel: t('GENERAL.NO'),
    })
      .then(() => {
        setLoading(true);
        prepareActivateMutation({
          variables: {
            id: consultant.id,
          },
          refetchQueries: ['consultantDetail'],
        })
          .then(() => {
            displaySuccess(t('CONSULTANT.PREPARE_ACTIVATE.ACTIVATE_SUCCESS'));
            refetch();
          })
          .catch(() =>
            displayAlert(t('CONSULTANT.PREPARE_ACTIVATE.ACTIVATE_FAILED'))
          )
          .finally(() => {
            setLoading(false);
          });
      })
      .catch(() => {});
  };

  return (
    <Button
      variant="outlined"
      size="small"
      loading={loading}
      disabled={!!consultant?.number}
      onClick={onClick}
    >
      <Trans>CONSULTANT.PREPARE_ACTIVATE.BUTTON</Trans>
    </Button>
  );
};

export default ButtonPrepareActivateConsultant;
